import React from 'react';
import { Box, Typography } from '@mui/material';
import { HealthcheckItem, HealthcheckSectionConfig } from '../../types';
import { HealthcheckStatus } from '../../fields';

interface HealthcheckSectionProps {
  healthcheck?: HealthcheckItem;
  config?: HealthcheckSectionConfig;
  title?: string;
  statusConfig?: Record<string, { textColor: string; buttonColor: string }>;
  getStatusByMonths?: (months: number) => string;
}

const HealthcheckSection: React.FC<HealthcheckSectionProps> = ({
  healthcheck,
  config,
  title,
  statusConfig,
  getStatusByMonths,
}) => {
  if (!config?.enabled || !healthcheck) {
    return null;
  }

  if (config.customRenderer) {
    return <>{config.customRenderer(healthcheck)}</>;
  }

  return (
    <Box sx={{ mb: 2 }}>
      <Box display="flex" alignItems="center" justifyContent="space-between" mb={0.5}>
        <Typography variant="subtitle2" color="textSecondary">
          {title}
        </Typography>
      </Box>
      {statusConfig && getStatusByMonths && (
        <HealthcheckStatus statusConfig={statusConfig} getStatusByMonths={getStatusByMonths} />
      )}
    </Box>
  );
};

export default HealthcheckSection;
